import { ILogger } from '@cian/logger';

import { GuardError } from '../../errors/GuardError';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { TMessage } from '../../types/postMessage';
import { isInIframe } from '../isInIframe';
import { getGenericLikeError } from '../logging/getGenericLikeError';

interface IPostFrameMessageParams {
  message: TMessage;
  targetOrigin: string;
  logger: ILogger;
}

const DEFAULT_EXCEPTION_MESSAGE = 'Ошибка при вызове postMessage в iframe';

export function postFrameMessage({ message, targetOrigin, logger }: IPostFrameMessageParams) {
  const isIframe = isInIframe();

  if (!isIframe || !window.parent) {
    const exception = new GuardError({
      domain: EExceptionDomain.Iframe,
      message: 'Попытка вызвать postMessage не в iframe',
    });

    logger.warning(exception);

    return;
  }

  try {
    window.parent.postMessage(message, targetOrigin);
  } catch (error) {
    const errorToLog = getGenericLikeError({
      error,
      domain: EExceptionDomain.Iframe,
      message: DEFAULT_EXCEPTION_MESSAGE,
    });

    logger.warning(errorToLog, {
      message: JSON.stringify(message),
      targetOrigin,
    });
  }
}
